import { render, staticRenderFns } from "./vip_mycenter.vue?vue&type=template&id=c82ca494&"
import script from "./vip_mycenter.vue?vue&type=script&lang=js&"
export * from "./vip_mycenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports